import { injectable } from "inversify"

import * as Api from "../constants/ApiUrlConstants"
import container from "../wires/Bootstrapper"
import SERVICE_IDENTIFIER from "../wires/Identifiers"

import { IApiService } from "./shared/ApiService"
import { IApiServiceExt } from "./shared/ApiServiceExt"
import { ISessionStorageService } from "./shared/StorageService"

import { AvailableYearsModel } from "../models/UtilityModels"
import { EmbedConfig } from "../models/EmbedConfig"
import { ModelBase } from "../models/ModelBase"

export interface IUtilityService {
    GetSelectedYear(): number
    SetSelectedYear(value: number)
    GetAvailableYears(ClienteId?: string): Promise<AvailableYearsModel>
    GetReport(ReportId: string, WorkspaceId: string): Promise<EmbedConfig>
    GetDashboard(DashboardId: string, WorkspaceId: string, DatasetId: string): Promise<EmbedConfig> 
    GetReportByName(Name: string, ClienteId: string): Promise<EmbedConfig> 
    RefreshMLModel(): Promise<ModelBase>
    GetStatoOperativo(): Promise<any>
    ContattaConsulente(): Promise<ModelBase>
}

const STORAGE_KEY_SELECTED_YEAR = "selected_year"

@injectable()
export class UtilityService implements IUtilityService {

    apiService: IApiService
    apiServiceExt: IApiServiceExt
    storageService: ISessionStorageService


    constructor() {
        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE)
        this.apiServiceExt = container.get(SERVICE_IDENTIFIER.API_SERVICE_EXT)
        this.storageService = container.get(SERVICE_IDENTIFIER.SESSION_STORAGE_SERVICE)
    }

    GetSelectedYear(): number {
        let year = this.storageService.GetNumber(STORAGE_KEY_SELECTED_YEAR)
        if (year == null) {
            year = new Date().getFullYear()
            this.SetSelectedYear(year)
        }

        return year
    }

    SetSelectedYear(value: number) {
        this.storageService.SetNumber(STORAGE_KEY_SELECTED_YEAR, value)
    }

    async GetAvailableYears(ClienteId?: string): Promise<AvailableYearsModel> {
        return await this.apiService.getAsync<AvailableYearsModel>(Api.GetAvailableYears, { ClienteId })
    }

    async GetReport(ReportId: string, WorkspaceId: string): Promise<EmbedConfig> {
        return await this.apiService.getAsync<EmbedConfig>(Api.GetReport, {ReportId , WorkspaceId})
    }

    async GetDashboard(DashboardId: string, WorkspaceId: string, DatasetId:string): Promise<EmbedConfig> {
        return await this.apiService.getAsync<EmbedConfig>(Api.GetDashboard, { DashboardId, WorkspaceId, DatasetId })
    }

    async GetReportByName(Name: string, ClienteId: string): Promise<EmbedConfig> {
        return await this.apiService.getAsync<EmbedConfig>(Api.GetReportByName, { Name, ClienteId })
    }

    async RefreshMLModel(): Promise<ModelBase> {
        return await this.apiServiceExt.getAsync(Api.RefreshMLModel,"")
    }

    async ContattaConsulente(): Promise<ModelBase> {
        return await this.apiServiceExt.getAsync(Api.ContattaConsulente, "")
    }
    async GetStatoOperativo(): Promise<any> {
        return await this.apiService.getAsync(Api.GetStatoOperativo, "")
    }
}